import { ref } from 'vue';
import { defineStore } from 'pinia';

const useAuthStore = defineStore('auth', () => {
  // State
  const userSettings = ref(null);
  const userProfile = ref(null);
  const isUserAuthenticated = ref(false);
  const pwdChangeUser = ref(null);
  const userRoles = ref([]);

  // Actions
  const setUserSettings = (payload) => (userSettings.value = payload);
  const setUserProfile = (payload) => (userProfile.value = payload);
  const setUserAuthenticated = (payload) =>
    (isUserAuthenticated.value = payload);
  const setPwdChangeUser = (payload) => (pwdChangeUser.value = payload);
  const setUserRoles = (payload) => (userRoles.value = payload);

  return {
    userSettings,
    userProfile,
    isUserAuthenticated,
    pwdChangeUser,
    userRoles,
    setUserSettings,
    setUserProfile,
    setUserAuthenticated,
    setPwdChangeUser,
    setUserRoles
  };
});

export default useAuthStore;
